// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"95":"b9501a02","117":"d4964b55","170":"e2607f06","492":"d0ce7315","528":"a94c674e","592":"90305d2f","769":"5d310319","782":"518ecfca"}[chunkId] + ".js";
};